import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import {
  setDamageReports,
  setDamageReportFailure,
} from '../state/action/damageAction';
import { GET_DAMAGE_REPORTS } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getReports({ projectNo }) {
  let status = 0;
  try {
    const projNo = encodeURIComponent(projectNo.projectNo).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const res = yield fetch(`${BASE_URL}/project/get-damage-reports?project_numbers=${projNo}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setDamageReports({ response }));
  } catch (error) {
    yield put(setDamageReportFailure());
    notification.destroy();
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* damageReportWatcher() {
  yield takeLatest(GET_DAMAGE_REPORTS, getReports);
}

function* damageReportSagas() {
  yield all([
    call(damageReportWatcher),
  ]);
}

export default damageReportSagas;
